/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { getHtmlByProductNumberAsync } from '../../actions/DataActionExtension.g';

import { IEcommProductDescriptionData } from './ecomm-product-description.data';
import { IEcommProductDescriptionProps } from './ecomm-product-description.props.autogenerated';

export interface IEcommProductDescriptionViewProps extends IEcommProductDescriptionProps<IEcommProductDescriptionData> {
    markup: string;
}

/**
 *
 * EcommProductDescription component
 * @extends {React.PureComponent<IEcommProductDescriptionProps<IEcommProductDescriptionData>>}
 */
class EcommProductDescription extends React.PureComponent<IEcommProductDescriptionProps<IEcommProductDescriptionData>> {
    public state: any = { markup: '' };

    public async componentDidMount() {
        const {
            config,
            data: { product }
        } = this.props;

        let value = '';

        if (product.result) {
            value = `${`${product.result.ItemId?.toString()}.html`}`;
        } else if (window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            const eventId = urlParams.get('id');

            value = eventId ? `${eventId}.html` : value;
        }

        if (this.state.markup === '' && value !== '') {
            const result = await getHtmlByProductNumberAsync(
                { callerContext: this.props.context.actionContext },
                config.env,
                config.entity,
                config.containerName,
                value
            );

            // If not html given, contents are ""}.
            const contents = result && result !== '' && !this._isTemplateProvided(JSON.stringify(result)) ? result : '';

            if (contents) {
                this.setState({ markup: result });
            } else {
                this.setState({ markup: '' });
            }
        } else {
            this.setState({ markup: '' });
        }
    }

    private _isTemplateProvided = (str: string): boolean => {
        try {
            const parsedJSON = JSON.parse(str);
            const parse = parsedJSON && parsedJSON !== '' && parsedJSON['value'] === '' ? 'TemplateNotProvided' : '';
            if (!parse) {
                return false;
            }
        } catch (e) {
            return false;
        }
        return true;
    };

    public render(): JSX.Element | null {
        const EcommProductDescriptionView = {
            ...this.props,
            markup: this.state.markup
        };

        return this.props.renderView(EcommProductDescriptionView);
    }
}

export default EcommProductDescription;
